import {
  ParentChildRelationshipAlreadyExistsError,
  ParentChildrenLimitExceededError,
  ParentNotFoundByCodeError,
  ParentNotFoundError,
  UserNotAllowedToConnectToSelfError
} from "@seneca/parents-service-client";
import ChildToParentLimitExceededError from "@seneca/parents-service-client/out/errors/ChildToParentLimitExceededError";

import { throttledLogError } from "seneca-common/utils/apiStates";

import parentsServiceErrorTranslator from "./errorTranslator";

export default function errorHandler(
  error: Error,
  {
    successAction,
    errorAction
  }: {
    successAction: (arg0?: any) => void;
    errorAction: (arg0?: any) => void;
  }
) {
  if (error instanceof ParentNotFoundError) {
    return successAction();
  }

  errorAction(parentsServiceErrorTranslator(error));

  if (
    !(
      error instanceof ParentChildRelationshipAlreadyExistsError ||
      error instanceof ParentNotFoundByCodeError ||
      error instanceof ParentChildrenLimitExceededError ||
      error instanceof UserNotAllowedToConnectToSelfError ||
      error instanceof ChildToParentLimitExceededError
    )
  ) {
    throttledLogError(error);
  }
}
